import React, { useState } from 'react';

// Federation payment rails — order is fixed: Gumroad · PayPal · JIM · Crypto.
// Rendered as semantic HTML so crawlers read every rail without executing JS.
const LINK_RAILS = [
  { id: 'gumroad', label: 'Gumroad', href: 'https://keywebster.gumroad.com', hint: 'Keys & SIM tokens', accent: '#ff90e8' },
  { id: 'paypal', label: 'PayPal', href: 'https://www.paypal.com/ncp/payment/F9GE2TLQKHY3E', hint: 'Card · debit · PayPal balance', accent: '#00ffff' },
  { id: 'jim', label: 'JIM', href: 'https://jim.com/a/roger-christopher-keyser', hint: 'Pay via JIM', accent: '#ffd700' },
];

const WALLETS = [
  { id: 'btc', label: 'Bitcoin (BTC)', address: 'bc1qzwjzf83u7nz2fx4frchncvgvyu902xfwn2y8dm', accent: '#ffa500' },
  { id: 'eth', label: 'Ethereum (ETH)', address: '0xdC436a568AcC70D2c34B07f2590dd94f0F2Fd702', accent: '#00ff88' },
];

export const PaymentRails = ({ heading = 'Payment Options' }) => {
  const [copied, setCopied] = useState('');

  const copyAddress = async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(id);
      setTimeout(() => setCopied(''), 1600);
    } catch (e) {
      /* clipboard unavailable */
    }
  };

  return (
    <section
      data-testid="payment-rails"
      aria-label="Payment options"
      style={{
        maxWidth: 860,
        margin: '1.5rem auto',
        padding: '1.5rem',
        background: '#000',
        border: '1px solid rgba(255,215,0,0.35)',
        borderRadius: 10,
        boxShadow: '0 0 24px rgba(0,240,255,0.08)',
      }}
    >
      {heading && (
        <h3
          data-testid="payment-rails-heading"
          style={{
            margin: '0 0 1rem',
            textAlign: 'center',
            color: '#ffd700',
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '1rem',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
          }}
        >
          {heading}
        </h3>
      )}

      <nav aria-label="Payment rails" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', justifyContent: 'center' }}>
        {LINK_RAILS.map((r) => (
          <a
            key={r.id}
            data-testid={`rail-${r.id}`}
            href={r.href}
            target="_blank"
            rel="noopener noreferrer"
            title={r.hint}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.15rem',
              minWidth: 150,
              padding: '0.75rem 1.25rem',
              textDecoration: 'none',
              color: '#fff',
              background: 'rgba(255,255,255,0.03)',
              border: `1px solid ${r.accent}`,
              borderRadius: 8,
              transition: 'background-color 0.25s ease, transform 0.25s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <span style={{ color: r.accent, fontWeight: 700, letterSpacing: '0.06em' }}>{r.label}</span>
            <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.6)' }}>{r.hint}</span>
          </a>
        ))}
      </nav>

      {/* Crypto rail — direct wallet addresses (no processor) */}
      <div
        data-testid="rail-crypto"
        style={{
          marginTop: '1rem',
          padding: '1rem',
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,215,0,0.35)',
          borderRadius: 8,
        }}
      >
        <div style={{ textAlign: 'center', color: '#ffd700', fontWeight: 700, letterSpacing: '0.06em', marginBottom: '0.75rem' }}>
          Crypto — direct wallet
        </div>
        {WALLETS.map((w) => (
          <div
            key={w.id}
            data-testid={`crypto-${w.id}`}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 0',
              borderTop: '1px solid rgba(255,255,255,0.06)',
            }}
          >
            <span style={{ color: w.accent, fontWeight: 700, minWidth: 130 }}>{w.label}</span>
            <code
              data-testid={`crypto-${w.id}-address`}
              style={{
                flex: 1,
                minWidth: 0,
                overflowWrap: 'anywhere',
                color: 'rgba(255,255,255,0.85)',
                fontSize: '0.8rem',
                fontFamily: "'JetBrains Mono', monospace",
              }}
            >
              {w.address}
            </code>
            <button
              type="button"
              data-testid={`copy-${w.id}`}
              onClick={() => copyAddress(w.id, w.address)}
              style={{
                cursor: 'pointer',
                padding: '0.35rem 0.75rem',
                color: '#000',
                background: w.accent,
                border: 'none',
                borderRadius: 6,
                fontWeight: 700,
                fontSize: '0.72rem',
              }}
            >
              {copied === w.id ? 'Copied' : 'Copy'}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PaymentRails;
